import { MarkDirtyFormAction, MarkCleanFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Store } from '@ngrx/store';
import { Subscription, combineLatest } from 'rxjs';
import { NgForm } from '@angular/forms';
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Role } from 'src/app/data/models/role.model';
import { UserRoleService } from 'src/app/services/user-role.service';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/services/company.service';
import { SelectionModel } from '@angular/cdk/collections';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-create-role',
  templateUrl: './create-role.component.html',
  styleUrls: ['./create-role.component.scss']
})
export class CreateRoleComponent implements OnInit, AfterViewInit, OnDestroy {

  displayedColumns = ['permissions', 'description', 'permissionRole'];

  listPermissions: any[];
  listPermissionsModule: any[];
  listRoles: object[];
  dataSource: MatTableDataSource<any>;
  moduleDataSource: MatTableDataSource<any>;
  buildDataSourceModule: MatTableDataSource<any>;
  fbDataSource: MatTableDataSource<any>;
  roleid;
  editedRole;
  companyId: number;
  listCompany: any[];
  selectedCompanyId: number;

  role = new Role({
    id: null,
    isSelected: false,
    roleName: '',
    description: '',
  });
  isDisabled = false;
  selection = new SelectionModel<any>(true, []);
  moduleSelection = new SelectionModel<any>(true, []);
  @ViewChild('createRoleForm', { static: false }) createRoleForm: NgForm;
  formChangesSubscription: Subscription;
  moduleList: any[];
  modulePermission: any;
  defaultModule: any;
  isImmigrationRole = false;

  constructor(
    private userRoleService: UserRoleService,
    private companyApiService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    protected store: Store<any>
  ) { }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  isAllSelectedModule(mod) {
    const numSelected = this.selectedMod(mod);
    const numRows = mod.permissionList.length;
    return numSelected === numRows;
  }

  selectedMod(mod) {
    let count = 0;
    mod.permissionList.forEach(perm => {
      count = (perm.isSelected) ? count + 1 : count;
    });
    return count;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      // this.selection.clear() :
      this.dataSource.data.forEach((row) => {
        this.selection.clear();
        row.isSelected = false;
      }) :
      this.dataSource.data.forEach((row) => {
        this.selection.select(row);
        row.isSelected = true;
      });
  }

  masterToggleModule(mod) {
    this.isAllSelectedModule(mod) ?
      // this.selection.clear() :
      mod.permissionList.forEach((row) => {
        row.isSelected = false;
      }) :
      mod.permissionList.forEach((row) => {
        row.isSelected = true;
      });
  }

  ngOnInit() {
    combineLatest([
      this.companyApiService
        .getCompanyHierarchyById(parseInt(sessionStorage.getItem('selectedCompanyId'))),
      this.userRoleService.getModuleList(),
      this.userRoleService.getPermissions()
    ])
      .pipe(take(1))
      .subscribe((data: any[]) => {
        this.listCompany = data[0];
        this.moduleList = data[1];
        this.listPermissions = data[2]['permissionList'];
        this.listPermissionsModule = data[2]['modulePermissions'];
        if (localStorage.getItem('role')) {
          this.populateEditRole();
        }
        const filteredListPermissions = this.listPermissions.filter(x => x.category);
        this.dataSource = new MatTableDataSource(filteredListPermissions.filter(x => x.category === 'STANDARD'));
        this.fbDataSource = new MatTableDataSource(filteredListPermissions.filter(x => x.category === 'FORMS_BUILDER'));
        this.immigrationChecked();
      });
  }

  immigrationChecked() {
    if (!this.isImmigrationRole) {
      let modObj = this.listPermissionsModule[0];
      modObj.isDefaultModule = false;
      this.moduleDataSource = new MatTableDataSource(modObj['permissionList']);
      this.modulePermission = modObj;
    } else {
      this.modulePermission = null;
      this.moduleDataSource = null;
    }
  }

  populateEditRole() {
    this.editedRole = JSON.parse(localStorage.getItem('role'));
    this.role.roleName = this.editedRole.name;
    this.role.description = this.editedRole.description;
    this.role.id = this.editedRole.id;
    this.companyId = this.editedRole.companyId;
    this.isDisabled = true;
    this.listPermissions.forEach((item) => {
      if (this.editedRole.permissionList?.find(x => x.id === item.id)) {
        this.selection.select(item);
        item.isSelected = true;
      } else {
        item.isSelected = false;
      }
    });
    if (this.editedRole.modulePermissions?.length > 0) {
      this.isImmigrationRole = false;
      this.modulePermission = this.editedRole.modulePermissions[0];

      // this.selectedModule = this.modulePermission.moduleId;
      if (this.modulePermission.isDefaultModule === 'Y') {
        this.modulePermission.isDefaultModule = true;
      } else {
        this.modulePermission.isDefaultModule = false;
      }
      const filteredListPermissionsModule = this.listPermissionsModule.find(x => x.moduleId == this.modulePermission.moduleId);
      if (filteredListPermissionsModule?.permissionList) {
        this.modulePermission.permissionList = Object.assign([], filteredListPermissionsModule.permissionList);
        if (this.modulePermission.permissionList?.length > 0) {
          this.modulePermission.permissionList.forEach(perm => {
            if (this.modulePermission.permissionIds.indexOf(perm.id) >= 0) {
              perm.isSelected = true;
            } else {
              perm.isSelected = false;
            }
          })
        }
      }
    } else {
      this.isImmigrationRole = true;
    }
  }

  markDefaultModule(mod) {
    mod.isDefaultModule = mod.isDefaultModule;
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.createRoleForm.statusChanges.subscribe(() => {
      if (this.createRoleForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({ dirty: true }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      }
    });
  }

  handleChange(row) {
    this.selection.toggle(row);
  }



  // handleChange(row) {
  //   this.selection.toggle(row);
  //   this.dataSource.data.find(x => x.id === row.id).isSelected = !this.dataSource.data.find(x => x.id === row.id).isSelected;
  // }

  createNewRole(createRoleForm) {
    // if (sessionStorage.getItem('userTypeRole') === Roles.PLATFORMADMIN) {
    //   this.companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));
    // } else {
    //   this.companyId = parseInt(sessionStorage.getItem('companyId'));
    // }

    // this.companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));

    if (createRoleForm.invalid) {
      return false; // invalid form submission stopped !
    }
    // this.modulePermissions.forEach((Permission) =>{
    //   Permission.isDefaultModule = (this.defaultModule.id === Permission.id ? 'Y' : 'N' )})
    const payload = {
      companyId: this.companyId,
      description: this.role.description,
      id: this.role.id || null,
      name: this.role.roleName,
      modulePermissions: [],
      permissionIds: [],
    };
    this.dataSource.data.filter(x => x.isSelected && x.isSelected === true).forEach((permission) => {
      payload.permissionIds.push(permission.id);
    });
    this.fbDataSource.data.filter(x => x.isSelected && x.isSelected === true).forEach((permission) => {
      payload.permissionIds.push(permission.id);
    });
    if (this.modulePermission) {
      this.modulePermission['permissionIds'] = [];
      this.modulePermission.permissionList.filter(x => x.isSelected && x.isSelected === true).forEach((permission) => {
        this.modulePermission['permissionIds'].push(permission.id);
      });
      // this.modulePermission.isDefaultModule = this.modulePermission.isDefaultModule ? 'Y' : 'N';
      this.modulePermission.isDefaultModule = 'Y';
      payload.modulePermissions.push(this.modulePermission);
    }


    // this.dataSource.data.filter(x => x.isSelected && x.isSelected === true).forEach((permission) => {
    //   payload['modulePermissions']['permissionIds'].push(permission.id);
    // });

    this.userRoleService.saveRole(payload)
      .pipe(take(1))
      .subscribe(() => {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        if (localStorage.getItem('role')) {
          this.toastr.success('Role updated successfully', 'Success');
        } else {
          this.toastr.success('New role created', 'Success');
        }
        this.router.navigate(['../roleslist'], { relativeTo: this.route });
      });
  }

  companySelected(e) {
    this.companyId = e.value;
  }

  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    if ('role' in localStorage) {
      localStorage.removeItem('role');
    }
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }

}

